/**
 * Phase 135B — /livex/replays/public/:slug (PUBLIC shareable replay page)
 * Uses raw fetch (no auth header) so it works for unauthenticated visitors.
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LivexReplayPlayer from '@/components/livex/LivexReplayPlayer';
import { AlertTriangle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LivexPublicReplay() {
  const { slug } = useParams();
  const [replay, setReplay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    fetch(`${API}/livex/public/replays/${slug}`)
      .then((r) => {
        if (!r.ok) throw new Error(r.status === 404 ? 'not_found' : 'fetch_failed');
        return r.json();
      })
      .then((d) => active && setReplay(d))
      .catch((e) => active && setError(e.message === 'not_found' ? 'This replay is no longer available — it may have expired or been removed.' : 'Could not load this replay.'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-white" style={{ background: '#0a0a0f' }}>
        <Loader2 className="h-6 w-6 animate-spin text-[#FF5A1F]" />
      </div>
    );
  }
  if (error || !replay) {
    return (
      <div className="min-h-screen grid place-items-center text-white px-6" style={{ background: '#0a0a0f' }} data-testid="livex-public-replay-error">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-12 w-12 mx-auto text-rose-400 mb-3" />
          <h1 className="text-xl font-black">Replay unavailable</h1>
          <p className="livex-body-text mt-2">{error || 'Replay not found.'}</p>
          <a
            href="/streamx"
            className="inline-flex items-center gap-2 mt-6 px-5 py-3 text-sm font-bold text-white rounded-xl border-2 border-[#FF5A1F]"
            style={{ background: 'linear-gradient(135deg, #dc2626, #f97316)' }}
          >
            Explore StreamX
          </a>
        </div>
      </div>
    );
  }
  return <LivexReplayPlayer replay={replay} mode="public" />;
}
